import React, { useState, useEffect, Fragment } from "react";
import { Link } from "gatsby";
import Image from "gatsby-image";
import Loader from "react-loader-spinner";
import {
	Subheading,
	Heading,
	BodyText,
	BodyTextAlt,
} from "~/components/.base/headings";
import { WhiteButton } from "~/components/.base/buttons";
import {
	Grid,
	Row,
	Col,
	CenteredContainer,
	FlexBox,
} from "~/components/.base/containers";
import { dayMap, monthMap } from "../helper-objects.js";
import { formatTime, formatTitle, formatAddress } from "./helpers";
import FoodTruckIcon from "~/images/icons/food_truck.svg";
import ForkKnifeIcon from "~/images/icons/fork_knife.svg";
import PhoneIcon from "~/images/icons/phone.svg";
import MailIcon from "~/images/icons/email.svg";
import ClockIcon from "~/images/icons/location_clock.svg";
import ArrowDownIcon from "~/images/icons/arrow_normal_down.svg";
import "./SearchResults.scss";

const SearchResults = ({
	searchResults,
	isLoading,
	stateQuery,
	searchQuery,
}) => {
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [weekDates, setWeekDates] = useState([]);
	const [isSticky, setIsSticky] = useState(false);
	const [refetch, setRefetch] = useState(false);
	useEffect(() => {
		var curr = new Date(); // get current date
		var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
		var last = first + 6; // last day is the first day + 6
		const firstDate = new Date(curr);
		firstDate.setDate(first);
		setStartDate(firstDate);
		const lastDate = new Date(curr);
		lastDate.setDate(last);
		setEndDate(lastDate);
		let weekDateArr = [];
		for (let i = 0; i < 7; i++) {
			let d = new Date(curr);
			d.setDate(first + i);
			weekDateArr.push(d);
		}
		setWeekDates(weekDateArr);
	}, []);
	useEffect(() => {
		const dateList = document.querySelector(".date-list");
		const dateResults = document.querySelectorAll(".schedule-cont");
		const prevButton = document.querySelector(
			".date-list-cont .prev-next.prev"
		);
		const nextButton = document.querySelector(
			".date-list-cont .prev-next.next"
		);
		const scrollLeft = async function() {
			await dateList.scroll({
				left: dateList.scrollLeft - 188,
				behavior: "smooth",
			});
			syncScroll({ target: dateList }, -188);
		};
		const scrollRight = async function() {
			await dateList.scroll({
				left: dateList.scrollLeft + 188,
				behavior: "smooth",
			});
			syncScroll({ target: dateList }, 188);
		};
		const syncScroll = function(e, offset) {
			dateList.scrollLeft = e.target.scrollLeft + offset;
			dateResults.forEach((el) => {
				el.scrollLeft = e.target.scrollLeft + offset;
			});
		};
		prevButton.addEventListener("click", scrollLeft);
		nextButton.addEventListener("click", scrollRight);
		// dateList.addEventListener("scroll", syncScroll);
		// for (let dateNode of dateResults) {
		// 	dateNode.addEventListener("scroll", syncScroll);
		// }
		return function() {
			prevButton.removeEventListener("click", scrollLeft);
			nextButton.removeEventListener("click", scrollRight);
			// dateList.removeEventListener("scroll", syncScroll);
			// for (let dateNode of dateResults) {
			// 	dateNode.removeEventListener("scroll", syncScroll);
			// }
		};
	}, [searchResults]);
	useEffect(() => {
		if (window) {
			var lastScrollTop = 0;
			var stickyDates = document.querySelector("#sticky-dates");
			var stickyNav = document.querySelector("#sticky-nav");
			const headerScroll = function() {
				if (window.innerWidth > 950) {
					var st = window.pageYOffset;
					if (stickyDates && stickyNav) {
						if (st > 205) {
							setIsSticky(true);
							if (st > lastScrollTop) {
								stickyDates.classList.remove("scroll-up");
								stickyNav.classList.add("hidden");
							} else {
								stickyDates.classList.add("scroll-up");
								stickyNav.classList.remove("hidden");
							}
						} else {
							stickyNav.classList.add("hidden");
							setIsSticky(false);
						}
						lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
					} else {
						setTimeout(() => setRefetch((r) => !r), 1000);
					}
				}
			};
			const reqFrame = () => {
				requestAnimationFrame(headerScroll);
			};
			window.addEventListener("scroll", reqFrame, false);
			return function cleanup() {
				window.removeEventListener("scroll", reqFrame);
			};
		}
	}, [refetch]);
	const formatDate = (date, hasMonth) => {
		let suffix = "th";
		if (
			date.getDate() === 1 ||
			date.getDate() === 21 ||
			date.getDate() === 31
		) {
			suffix = "st";
		}
		if (date.getDate() === 2 || date.getDate() === 22) {
			suffix = "nd";
		}
		if (date.getDate() === 3 || date.getDate() === 23) {
			suffix = "rd";
		}
		if (hasMonth) {
			return (
				<span>
					<span className="red">{dayMap[date.getDay()]}</span>
					<br />
					{monthMap[date.getMonth()].slice(0, 3)}{" "}
					{date.getDate() + suffix}
				</span>
			);
		}
		return `${dayMap[date.getDay()] + " " + date.getDate() + suffix}`;
	};
	console.log(searchResults);
	return (
		<div className="search-results">
			<Grid
				id="sticky-dates"
				className={`dates-cont${isSticky ? " sticky" : ""}`}
			>
				<Row className="dates">
					<Col className="date-range" size={2} pd="22px 20px">
						<Subheading md="0">
							<span className="query-string">
								{stateQuery ? `${stateQuery} - ` : ""}
							</span>
							<span className="query-string">
								{searchQuery ? `${searchQuery} - ` : ""}
							</span>{" "}
							{startDate && endDate
								? `${formatDate(startDate, false)} -
					${formatDate(endDate, false)}`
								: ""}
						</Subheading>
					</Col>
					<Col className="date-list-cont" size={5}>
						<WhiteButton className="no-stroke prev-next prev">
							<ArrowDownIcon />
						</WhiteButton>
						<div className="date-list">
							{weekDates.map((date, i) => (
								<div key={i} className="week-date">
									<Subheading md="0">
										{formatDate(date, true)}
									</Subheading>
								</div>
							))}
						</div>
						<WhiteButton className="no-stroke prev-next next">
							<ArrowDownIcon />
						</WhiteButton>
					</Col>
				</Row>
			</Grid>
			{isLoading ? (
				<CenteredContainer className="loading-cont">
					<FlexBox align="center">
						<Loader
							color="#d4212c"
							type="TailSpin"
							height={50}
							width={50}
						/>
					</FlexBox>
				</CenteredContainer>
			) : searchResults.length ? (
				<Grid className="results-cont">
					{searchResults.map((result, i) => {
						console.log(result);
						if (!result.contentfulDetails) return <div />;
						let maxDepthArr = new Array(result.maxEventDepth);
						maxDepthArr.fill(1);
						console.log(maxDepthArr);
						const {
							handle,
							title,
							emailAddress,
							phoneNumber,
							heroImage,
							isATruck,
						} = result.contentfulDetails.node;
						return (
							<Row key={i} className="result">
								<Col
									className="info-cont"
									size={2}
									pd="22px 20px"
								>
									<FlexBox
										className="title-cont"
										justify="space-between"
										align="center"
									>
										<Heading md="0">{title}</Heading>
										{isATruck ? (
											<WhiteButton className="no-hover no-stroke">
												<FoodTruckIcon />
											</WhiteButton>
										) : (
											<WhiteButton className="no-hover no-stroke">
												<ForkKnifeIcon />
											</WhiteButton>
										)}
									</FlexBox>
									<div className="events-cont">
										<BodyText className="event-info-text">
											<span className="mobile-red">
												<span className="red">
													{result.withinDistanceCount <
													10
														? `0${result.withinDistanceCount}`
														: result.withinDistanceCount}
												</span>{" "}
												events
											</span>{" "}
											{stateQuery
												? `near ${stateQuery}`
												: "near you"}{" "}
											this week
										</BodyText>
										<div className="image-cont">
											{heroImage ? (
												<Image
													fluid={heroImage.fluid}
													alt={title}
												/>
											) : (
												<img
													src="//images.ctfassets.net/fqko45mtq61h/3EjOJPGxAOr1yAb84R8LUP/649b573acce3dc40817834c493230189/nsh.jpg?w=1600&q=50"
													alt="DFW"
												/>
											)}
										</div>
									</div>
									<FlexBox
										className="contact-info"
										justify="space-between"
										direction="column"
									>
										{phoneNumber ? (
											<FlexBox align="center">
												<PhoneIcon />
												<a href={`tel:${phoneNumber}`}>
													{phoneNumber}
												</a>
											</FlexBox>
										) : null}
										{emailAddress ? (
											<FlexBox align="center">
												<MailIcon width="16px" />
												<a
													href={`mailto:${emailAddress}`}
												>
													{" "}
													{emailAddress}
												</a>
											</FlexBox>
										) : null}
									</FlexBox>
									<Link to={`/locations/details/${handle}`}>
										<WhiteButton width="100%">
											See truck schedule
										</WhiteButton>
									</Link>
								</Col>
								<Col className="schedule-cont" size={5}>
									{result && result.events ? (
										<Fragment>
											<div className="schedule-col">
												{result.events["Sunday"]
													? result.events[
															"Sunday"
													  ].map((event, i) => (
															<div
																key={i}
																className={`schedule-item ${
																	i ===
																		result
																			.events[
																			"Sunday"
																		]
																			.length -
																			1 &&
																	result
																		.events[
																		"Sunday"
																	].length >=
																		maxDepthArr.length
																		? "last"
																		: ""
																}`}
															>
																<Subheading>
																	{event.summary
																		? formatTitle(
																				event.summary
																		  )
																		: ""}
																</Subheading>
																{event.isWithinDistance ? (
																	<div class="within-distance">
																		Within
																		Range
																	</div>
																) : null}
																<FlexBox
																	className="time"
																	align="center"
																>
																	<ClockIcon />
																	<BodyTextAlt>
																		{formatTime(
																			event.start,
																			event.end
																		)}
																	</BodyTextAlt>
																</FlexBox>
																<a
																	href={`https://maps.google.com/?q=${formatAddress(
																		event.formattedAddress,
																		event.location
																	)}`}
																	target="_/blank"
																>
																	<BodyText>
																		{formatAddress(
																			event.formattedAddress,
																			event.location
																		)}
																	</BodyText>
																</a>
															</div>
													  ))
													: maxDepthArr.map(
															(a, i) => {
																if (i === 0) {
																	return (
																		<div className="empty-date first">
																			<Subheading>
																				No
																				events
																				scheduled
																			</Subheading>
																		</div>
																	);
																}
																return (
																	<div
																		className={`empty-date ${
																			i ===
																			maxDepthArr.length -
																				1
																				? "last"
																				: ""
																		}`}
																	/>
																);
															}
													  )}
												{result.events["Sunday"] &&
												result.events["Sunday"].length <
													maxDepthArr.length
													? maxDepthArr
															.slice(
																0,
																maxDepthArr.length -
																	result
																		.events[
																		"Sunday"
																	].length
															)
															.map((a, i) => (
																<div
																	className={`empty-date ${
																		i ===
																		maxDepthArr.length -
																			result
																				.events[
																				"Sunday"
																			]
																				.length -
																			1
																			? "last"
																			: ""
																	}`}
																/>
															))
													: null}
											</div>
											<div className="schedule-col">
												{result.events["Monday"]
													? result.events[
															"Monday"
													  ].map((event, i) => (
															<div
																key={i}
																className={`schedule-item ${
																	i ===
																		result
																			.events[
																			"Monday"
																		]
																			.length -
																			1 &&
																	result
																		.events[
																		"Monday"
																	].length >=
																		maxDepthArr.length
																		? "last"
																		: ""
																}`}
															>
																<Subheading>
																	{event.summary
																		? formatTitle(
																				event.summary
																		  )
																		: ""}
																</Subheading>
																{event.isWithinDistance ? (
																	<div class="within-distance">
																		Within
																		Range
																	</div>
																) : null}
																<FlexBox
																	className="time"
																	align="center"
																>
																	<ClockIcon />
																	<BodyTextAlt>
																		{formatTime(
																			event.start,
																			event.end
																		)}
																	</BodyTextAlt>
																</FlexBox>
																<a
																	href={`https://maps.google.com/?q=${formatAddress(
																		event.formattedAddress,
																		event.location
																	)}`}
																	target="_/blank"
																>
																	<BodyText>
																		{formatAddress(
																			event.formattedAddress,
																			event.location
																		)}
																	</BodyText>
																</a>
															</div>
													  ))
													: maxDepthArr.map(
															(a, i) => {
																if (i === 0) {
																	return (
																		<div className="empty-date first">
																			<Subheading>
																				No
																				events
																				scheduled
																			</Subheading>
																		</div>
																	);
																}
																return (
																	<div
																		className={`empty-date ${
																			i ===
																			maxDepthArr.length -
																				1
																				? "last"
																				: ""
																		}`}
																	/>
																);
															}
													  )}
												{result.events["Monday"] &&
												result.events["Monday"].length <
													maxDepthArr.length
													? maxDepthArr
															.slice(
																0,
																maxDepthArr.length -
																	result
																		.events[
																		"Monday"
																	].length
															)
															.map((a, i) => (
																<div
																	className={`empty-date ${
																		i ===
																		maxDepthArr.length -
																			result
																				.events[
																				"Monday"
																			]
																				.length -
																			1
																			? "last"
																			: ""
																	}`}
																/>
															))
													: null}
											</div>
											<div className="schedule-col">
												{result.events["Tuesday"]
													? result.events[
															"Tuesday"
													  ].map((event, i) => (
															<div
																key={i}
																className={`schedule-item ${
																	i ===
																		result
																			.events[
																			"Tuesday"
																		]
																			.length -
																			1 &&
																	result
																		.events[
																		"Tuesday"
																	].length >=
																		maxDepthArr.length
																		? "last"
																		: ""
																}`}
															>
																<Subheading>
																	{formatTitle(
																		event.summary
																	)}
																</Subheading>
																{event.isWithinDistance ? (
																	<div class="within-distance">
																		Within
																		Range
																	</div>
																) : null}
																<FlexBox
																	className="time"
																	align="center"
																>
																	<ClockIcon />
																	<BodyTextAlt>
																		{formatTime(
																			event.start,
																			event.end
																		)}
																	</BodyTextAlt>
																</FlexBox>
																<a
																	href={`https://maps.google.com/?q=${formatAddress(
																		event.formattedAddress,
																		event.location
																	)}`}
																	target="_/blank"
																>
																	<BodyText>
																		{formatAddress(
																			event.formattedAddress,
																			event.location
																		)}
																	</BodyText>
																</a>
															</div>
													  ))
													: maxDepthArr.map(
															(a, i) => {
																if (i === 0) {
																	return (
																		<div className="empty-date first">
																			<Subheading>
																				No
																				events
																				scheduled
																			</Subheading>
																		</div>
																	);
																}
																return (
																	<div
																		className={`empty-date ${
																			i ===
																			maxDepthArr.length -
																				1
																				? "last"
																				: ""
																		}`}
																	/>
																);
															}
													  )}
												{result.events["Tuesday"] &&
												result.events["Tuesday"]
													.length < maxDepthArr.length
													? maxDepthArr
															.slice(
																0,
																maxDepthArr.length -
																	result
																		.events[
																		"Tuesday"
																	].length
															)
															.map((a, i) => (
																<div
																	className={`empty-date ${
																		i ===
																		maxDepthArr.length -
																			result
																				.events[
																				"Tuesday"
																			]
																				.length -
																			1
																			? "last"
																			: ""
																	}`}
																/>
															))
													: null}
											</div>
											<div className="schedule-col">
												{result.events["Wednesday"]
													? result.events[
															"Wednesday"
													  ].map((event, i) => (
															<div
																key={i}
																className={`schedule-item ${
																	i ===
																		result
																			.events[
																			"Wednesday"
																		]
																			.length -
																			1 &&
																	result
																		.events[
																		"Wednesday"
																	].length >=
																		maxDepthArr.length
																		? "last"
																		: ""
																}`}
															>
																<Subheading>
																	{formatTitle(
																		event.summary
																	)}
																</Subheading>
																{event.isWithinDistance ? (
																	<div class="within-distance">
																		Within
																		Range
																	</div>
																) : null}
																<FlexBox
																	className="time"
																	align="center"
																>
																	<ClockIcon />
																	<BodyTextAlt>
																		{formatTime(
																			event.start,
																			event.end
																		)}
																	</BodyTextAlt>
																</FlexBox>
																<a
																	href={`https://maps.google.com/?q=${formatAddress(
																		event.formattedAddress,
																		event.location
																	)}`}
																	target="_/blank"
																>
																	<BodyText>
																		{event.formattedAddress
																			? event.formattedAddress
																			: event.location}
																	</BodyText>
																</a>
															</div>
													  ))
													: maxDepthArr.map(
															(a, i) => {
																if (i === 0) {
																	return (
																		<div className="empty-date first">
																			<Subheading>
																				No
																				events
																				scheduled
																			</Subheading>
																		</div>
																	);
																}
																return (
																	<div
																		className={`empty-date ${
																			i ===
																			maxDepthArr.length -
																				1
																				? "last"
																				: ""
																		}`}
																	/>
																);
															}
													  )}
												{result.events["Wednesday"] &&
												result.events["Wednesday"]
													.length < maxDepthArr.length
													? maxDepthArr
															.slice(
																0,
																maxDepthArr.length -
																	result
																		.events[
																		"Wednesday"
																	].length
															)
															.map((a, i) => (
																<div
																	className={`empty-date ${
																		i ===
																		maxDepthArr.length -
																			result
																				.events[
																				"Wednesday"
																			]
																				.length -
																			1
																			? "last"
																			: ""
																	}`}
																/>
															))
													: null}
											</div>
											<div className="schedule-col">
												{result.events["Thursday"]
													? result.events[
															"Thursday"
													  ].map((event, i) => (
															<div
																key={i}
																className={`schedule-item ${
																	i ===
																		result
																			.events[
																			"Thursday"
																		]
																			.length -
																			1 &&
																	result
																		.events[
																		"Thursday"
																	].length >=
																		maxDepthArr.length
																		? "last"
																		: ""
																}`}
															>
																<Subheading>
																	{event.summary
																		? formatTitle(
																				event.summary
																		  )
																		: ""}
																</Subheading>
																{event.isWithinDistance ? (
																	<div class="within-distance">
																		Within
																		Range
																	</div>
																) : null}
																<FlexBox
																	className="time"
																	align="center"
																>
																	<ClockIcon />
																	<BodyTextAlt>
																		{formatTime(
																			event.start,
																			event.end
																		)}
																	</BodyTextAlt>
																</FlexBox>
																<a
																	href={`https://maps.google.com/?q=${formatAddress(
																		event.formattedAddress,
																		event.location
																	)}`}
																	target="_/blank"
																>
																	<BodyText>
																		{formatAddress(
																			event.formattedAddress,
																			event.location
																		)}
																	</BodyText>
																</a>
															</div>
													  ))
													: maxDepthArr.map(
															(a, i) => {
																if (i === 0) {
																	return (
																		<div className="empty-date first">
																			<Subheading>
																				No
																				events
																				scheduled
																			</Subheading>
																		</div>
																	);
																}
																return (
																	<div
																		className={`empty-date ${
																			i ===
																			maxDepthArr.length -
																				1
																				? "last"
																				: ""
																		}`}
																	/>
																);
															}
													  )}
												{result.events["Thursday"] &&
												result.events["Thursday"]
													.length < maxDepthArr.length
													? maxDepthArr
															.slice(
																0,
																maxDepthArr.length -
																	result
																		.events[
																		"Thursday"
																	].length
															)
															.map((a, i) => (
																<div
																	className={`empty-date ${
																		i ===
																		maxDepthArr.length -
																			result
																				.events[
																				"Thursday"
																			]
																				.length -
																			1
																			? "last"
																			: ""
																	}`}
																/>
															))
													: null}
											</div>
											<div className="schedule-col">
												{result.events["Friday"]
													? result.events[
															"Friday"
													  ].map((event, i) => (
															<div
																key={i}
																className={`schedule-item ${
																	i ===
																		result
																			.events[
																			"Friday"
																		]
																			.length -
																			1 &&
																	result
																		.events[
																		"Friday"
																	].length >=
																		maxDepthArr.length
																		? "last"
																		: ""
																}`}
															>
																<Subheading>
																	{event.summary
																		? formatTitle(
																				event.summary
																		  )
																		: ""}
																</Subheading>
																{event.isWithinDistance ? (
																	<div class="within-distance">
																		Within
																		Range
																	</div>
																) : null}
																<FlexBox
																	className="time"
																	align="center"
																>
																	<ClockIcon />
																	<BodyTextAlt>
																		{formatTime(
																			event.start,
																			event.end
																		)}
																	</BodyTextAlt>
																</FlexBox>
																<a
																	href={`https://maps.google.com/?q=${formatAddress(
																		event.formattedAddress,
																		event.location
																	)}`}
																	target="_/blank"
																>
																	<BodyText>
																		{formatAddress(
																			event.formattedAddress,
																			event.location
																		)}
																	</BodyText>
																</a>
															</div>
													  ))
													: maxDepthArr.map(
															(a, i) => {
																if (i === 0) {
																	return (
																		<div className="empty-date first">
																			<Subheading>
																				No
																				events
																				scheduled
																			</Subheading>
																		</div>
																	);
																}
																return (
																	<div
																		className={`empty-date ${
																			i ===
																			maxDepthArr.length -
																				1
																				? "last"
																				: ""
																		}`}
																	/>
																);
															}
													  )}
												{result.events["Friday"] &&
												result.events["Friday"].length <
													maxDepthArr.length
													? maxDepthArr
															.slice(
																0,
																maxDepthArr.length -
																	result
																		.events[
																		"Friday"
																	].length
															)
															.map((a, i) => (
																<div
																	className={`empty-date ${
																		i ===
																		maxDepthArr.length -
																			result
																				.events[
																				"Friday"
																			]
																				.length -
																			1
																			? "last"
																			: ""
																	}`}
																/>
															))
													: null}
											</div>
											<div className="schedule-col">
												{result.events["Saturday"]
													? result.events[
															"Saturday"
													  ].map((event, i) => (
															<div
																key={i}
																className={`schedule-item ${
																	i ===
																		result
																			.events[
																			"Saturday"
																		]
																			.length -
																			1 &&
																	result
																		.events[
																		"Saturday"
																	].length >=
																		maxDepthArr.length
																		? "last"
																		: ""
																}`}
															>
																<Subheading>
																	{formatTitle(
																		event.summary
																	)}
																</Subheading>
																{event.isWithinDistance ? (
																	<div class="within-distance">
																		Within
																		Range
																	</div>
																) : null}
																<FlexBox
																	className="time"
																	align="center"
																>
																	<ClockIcon />
																	<BodyTextAlt>
																		{formatTime(
																			event.start,
																			event.end
																		)}
																	</BodyTextAlt>
																</FlexBox>
																<a
																	href={`https://maps.google.com/?q=${formatAddress(
																		event.formattedAddress,
																		event.location
																	)}`}
																	target="_/blank"
																>
																	<BodyText>
																		{formatAddress(
																			event.formattedAddress,
																			event.location
																		)}
																	</BodyText>
																</a>
															</div>
													  ))
													: maxDepthArr.map(
															(a, i) => {
																if (i === 0) {
																	return (
																		<div className="empty-date first">
																			<Subheading>
																				No
																				events
																				scheduled
																			</Subheading>
																		</div>
																	);
																}
																return (
																	<div
																		className={`empty-date ${
																			i ===
																			maxDepthArr.length -
																				1
																				? "last"
																				: ""
																		}`}
																	/>
																);
															}
													  )}
												{result.events["Saturday"] &&
												result.events["Saturday"]
													.length < maxDepthArr.length
													? maxDepthArr
															.slice(
																0,
																maxDepthArr.length -
																	result
																		.events[
																		"Saturday"
																	].length
															)
															.map((a, i) => (
																<div
																	className={`empty-date ${
																		i ===
																		maxDepthArr.length -
																			result
																				.events[
																				"Saturday"
																			]
																				.length -
																			1
																			? "last"
																			: ""
																	}`}
																/>
															))
													: null}
											</div>
										</Fragment>
									) : null}
								</Col>
							</Row>
						);
					})}
				</Grid>
			) : (
				<CenteredContainer className="no-results-cont">
					<div>No Results In Range.</div>
				</CenteredContainer>
			)}
		</div>
	);
};
export default SearchResults;
